<template>
    <div id="legal-notices">
        <ob1-liens-haut-bas
            :button-id="'legal-notices-header'"
            :button-label="title"
            :collapsed-block-id="'legal-notices-text'"
            :is-collapsed="false"
            :is-mini="true"
        >
            <div class="row py-1">
                <div v-for="(legalNotice, index) in legalNotices" :key="'legal-notice-'+index">
                    <div class="col-12 pb-1">
                        <strong
                            v-html="legalNotice.title"
                        />
                        <div
                            class="small p-0"
                            v-html="legalNotice.text"
                        />
                    </div>
                </div>
            </div>
        </ob1-liens-haut-bas>
    </div>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        legalNotices: {
            type: Array,
            required: true
        }
    }
}
</script>
